/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddFittingBtnComponent } from './add-fitting-btn.component';

@NgModule({
  declarations: [AddFittingBtnComponent],
  imports: [CommonModule],
  exports: [AddFittingBtnComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AddFittingBtnModule {}
